import { slugify } from "../../utils/string"

const productFormFormatMixin = {
    methods: {
        formatOptions(optionsArr) {
            let optionIndex = 0

            while (optionIndex < optionsArr.length) {
                const option = optionsArr[optionIndex]
                const optionName = option.name
                const optionValues = option.values

                option.ids = optionValues.map(optionValue => {
                    return slugify(`${optionName}-${optionValue}`)
                })

                optionIndex++
            }
        },

        formatOptionsColors(optionsArr, variantsArr) {
            let optionIndex = 0

            while (optionIndex < optionsArr.length) {
                const option = optionsArr[optionIndex]
                const optionValues = option.values

                option.colors = []

                optionValues.forEach((value) => {
                    const targetVariants = variantsArr.filter(variant => variant.optionsValues.indexOf(value) > -1)
                    const colors = targetVariants.map((variant) => variant.color)
                    const colorsFormatted = colors.filter(color => color) // Removing the empty strings
                    const color = colorsFormatted.length ? colorsFormatted[0] : ''
                    option.colors.push(color)

                    // console.log('optionObj', option)
                    // console.log('value', value)
                    // console.log('all variants', variantsArr)
                    // console.log('selectedVariants', targetVariants)
                    // console.log('colors', colors)
                    // console.log('colorsFormatted', colorsFormatted)
                    // console.log('-----------')
                })

                optionIndex++
            }
        },

        formatVariantsItems(variantsArr, optionsArr, quantityArr, colorsArr) {
            let variantsIndex = 0

            while (variantsIndex < variantsArr.length) {
                const variantObject = variantsArr[variantsIndex]    

                /////////////////////
                // Options
                /////////////////////
                // Add options array 
                variantObject.optionsValues =  variantObject.options.map((value, index) => {
                    return value
                })
                // Add options object
                variantObject.options = variantObject.options.map((value, index) => {
                    return { 
                        name: optionsArr[index].name, 
                        value: value
                    }
                })

                /////////////////////
                // Quantities
                /////////////////////
                const currentVariantQuantity = quantityArr.find(variant => variant.id === variantObject.id )

                // Add quantity number 
                variantObject.quantity = currentVariantQuantity.quantity

                /////////////////////
                // Colors
                /////////////////////
                const currentVariantColor = colorsArr.find(variant => variant.id === variantObject.id )

                // Add quantity number 
                variantObject.color = currentVariantColor?.color
                
                /////////////////////
                // Global ID
                // https://github.com/Shopify/mobile-buy-sdk-ios/issues/663#issuecomment-311369782
                // https://community.shopify.com/c/Shopify-APIs-SDKs/Getting-Global-ID/td-p/520191
                /////////////////////
                const baseGlobalId = `gid://shopify/ProductVariant/${variantObject.id}`
                variantObject.gid = btoa(baseGlobalId)
                
                variantsIndex++
            }
        }
    }
}

export default productFormFormatMixin;
